export const defaultZipCode = '30303'